import { render, staticRenderFns } from "./AIAutoImproveWritingButton.vue?vue&type=template&id=5785a9b3&scoped=true"
import script from "./AIAutoImproveWritingButton.vue?vue&type=script&lang=js"
export * from "./AIAutoImproveWritingButton.vue?vue&type=script&lang=js"
import style0 from "./AIAutoImproveWritingButton.vue?vue&type=style&index=0&id=5785a9b3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5785a9b3",
  null
  
)

export default component.exports